// Fechas y etiquetas en español de México, zona de Saltillo.
export const ZONA = "America/Monterrey";

export const ETIQUETA_ESTADO: Record<string, string> = {
  nueva: "Nuevo",
  incompleta: "Incompleto",
  asignada: "Asignado",
  en_proceso: "En proceso",
  en_revision: "En revisión",
  entregada: "Entregado",
  cerrada: "Cerrado",
  cancelada: "Cancelado",
};

export const ETIQUETA_PRIORIDAD: Record<string, string> = {
  baja: "Baja",
  normal: "Normal",
  alta: "Alta",
  urgente: "Urgente",
};

export const ETIQUETA_CANAL: Record<string, string> = {
  formulario: "Formulario",
  whatsapp: "WhatsApp",
  slack: "Slack",
  correo: "Correo",
  junta: "Junta",
  verbal: "De palabra",
  api: "API",
};

export const FLUJO = ["nueva", "asignada", "en_proceso", "en_revision", "entregada", "cerrada"] as const;

export function estadoLabel(e: string): string {
  return ETIQUETA_ESTADO[e] ?? e;
}

function d(iso: string | Date): Date {
  return iso instanceof Date ? iso : new Date(iso);
}

/** «mié 9 sep» */
export function fechaCorta(iso: string | Date | null | undefined): string {
  if (!iso) return "—";
  return d(iso).toLocaleDateString("es-MX", { weekday: "short", day: "numeric", month: "short", timeZone: ZONA }).replace(/\.,?/g, "");
}

/** «mié 9 sep, 16:48» */
export function fechaHora(iso: string | Date | null | undefined): string {
  if (!iso) return "—";
  return `${fechaCorta(iso)}, ${d(iso).toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", timeZone: ZONA })}`;
}

/** Fecha AAAA-MM-DD (sin hora) a «jueves 10 de septiembre». */
export function fechaLarga(aaaammdd: string | null | undefined): string {
  if (!aaaammdd) return "—";
  return new Date(`${aaaammdd}T12:00:00-06:00`).toLocaleDateString("es-MX", { weekday: "long", day: "numeric", month: "long", timeZone: ZONA });
}

/** «en 3 h», «hace 2 días», «vence hoy». */
export function relativo(iso: string | null | undefined, ahora: Date = new Date()): string {
  if (!iso) return "sin fecha límite";
  const ms = d(iso).getTime() - ahora.getTime();
  const abs = Math.abs(ms);
  const h = Math.round(abs / 3_600_000);
  const dias = Math.round(abs / 86_400_000);
  const cuanto = h < 1 ? "menos de una hora" : h < 36 ? `${h} h` : `${dias} ${dias === 1 ? "día" : "días"}`;
  return ms >= 0 ? `en ${cuanto}` : `hace ${cuanto}`;
}

export function horas(h: number | null | undefined): string {
  if (h === null || h === undefined) return "—";
  if (h < 1) return "menos de 1 h";
  if (h < 48) return `${Math.round(h * 10) / 10} h`;
  const dias = Math.round((h / 24) * 10) / 10;
  return `${dias} ${dias === 1 ? "día" : "días"}`;
}

export function slaTexto(h: number | null | undefined): string {
  if (h === null || h === undefined) return "sin SLA";
  if (h % 24 === 0 && h >= 48) return `${h / 24} días`;
  return `${h} h`;
}

export function pct(n: number | null | undefined): string {
  return n === null || n === undefined ? "—" : `${n} %`;
}

export function folio(n: number): string {
  return `SM-${String(n).padStart(4, "0")}`;
}
